import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { authInitialized } from "../reduxAuth/authSlice";
import dayjs, { Dayjs } from "dayjs";
import { ConsultingSlot } from "../../utils/global-types";

interface SettingSlice {
  kanbanStartDateTime: string;
  kanbanEndDateTime: string;
  consultingSlot: string;
  userSettingsInitialized: boolean;
  timezone: string;
}
interface IupdateUserSettings {
  kanbanStartDateTime: string;
  kanbanEndDateTime: string;
  consultingSlot: string;
  timezone: string;
}
const initialState: SettingSlice = {
  kanbanStartDateTime: dayjs().toISOString(),
  kanbanEndDateTime: dayjs().toISOString(),
  consultingSlot: ConsultingSlot.Day.toString(),
  userSettingsInitialized: false,
  timezone: "",
};
const settingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<IupdateUserSettings>) => {
      state.kanbanStartDateTime = action.payload.kanbanStartDateTime;
      state.kanbanEndDateTime = action.payload.kanbanEndDateTime;
      state.consultingSlot = action.payload.consultingSlot;
      state.timezone = action.payload.timezone;
    },
    initializeUserSettings: (state, action: PayloadAction<boolean>) => {
      state.userSettingsInitialized = action.payload;
    },
  },
});

export const { setSettings, initializeUserSettings } = settingSlice.actions;
export default settingSlice.reducer;
